import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=1c8c00de&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8c00de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8c00de')) {
      api.createRecord('1c8c00de', component.options)
    } else {
      api.reload('1c8c00de', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=1c8c00de&scoped=true&", function () {
      api.rerender('1c8c00de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UwaQmBcBT1Uj/JS/comp/Voucher-Unit.vue"
export default component.exports